import { Component, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-eula-agreement',
    templateUrl: './eula-agreement.component.html',
    styleUrls: ['./eula-agreement.component.scss'],
    standalone: false
})
export class EulaAgreementComponent {
	@ViewChild('eulaAgreement') eulaAgreement !: TemplateRef<any>;
	eulaPDF = '../assets/eula.pdf';
	zoom = 1;

	constructor(private modalService: NgbModal) {}

	openModal() {
		this.modalService.open(this.eulaAgreement, { size: 'xl', scrollable: true });
	}

	zoomUp() {
		if (this.zoom < 3) {
			this.zoom = this.zoom + 0.5;
		}
	}

	zoomDown() {
		if (this.zoom > 1) {
			this.zoom = this.zoom - 0.5;
		}
	}
}
